var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "form",
      staticClass: "back_to_top_config",
      attrs: { model: _vm.value.config, disabled: _vm.disabled },
    },
    [
      _c("div", { staticClass: "tips" }, [
        _vm._v(" 说明：每个页面只能有一个侧悬浮组件 "),
      ]),
      _c(
        "div",
        { staticClass: "box" },
        [
          _c("div", { staticClass: "type" }, [_vm._v(" 返回顶部图标 ")]),
          _c(
            "el-form-item",
            {
              attrs: {
                prop: "imageurl",
                rules: [{ required: true, message: "图标不可为空" }],
              },
            },
            [
              _c(
                "div",
                { staticClass: "upload-item-wrap" },
                [
                  _c("upload-file", {
                    ref: "uploadBanner",
                    attrs: {
                      "link-url": _vm.linkUrl,
                      tempurl: _vm.value.config.imageurl,
                      canDel: Boolean(_vm.value.config.imageurl),
                      deletePadding: true,
                      uploadInfo: _vm.uploadInfo,
                    },
                    on: {
                      onDelete: _vm.onDelete,
                      emitUploadFile: _vm.emitUploadFile,
                    },
                  }),
                  _c(
                    "div",
                    { staticClass: "right" },
                    [
                      _c("el-button", { on: { click: _vm.onUpload } }, [
                        _vm._v("上传图片"),
                      ]),
                      _vm.pictureList.length > 0
                        ? _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.selectPicture },
                            },
                            [_vm._v("选择图片")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("div", { staticClass: "tips" }, [
                _vm._v(" 建议尺寸为26px*26px，支持png格式，大小不超过2M "),
              ]),
            ]
          ),
        ],
        1
      ),
      _vm.showPictureLibrary
        ? _c("picture-library", {
            attrs: {
              configData: _vm.value,
              pictureList: _vm.pictureList,
              depot: _vm.depot,
            },
            on: {
              onClose: function ($event) {
                _vm.showPictureLibrary = false
              },
              onSubmit: _vm.onChangePic,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }